import { render, staticRenderFns } from "./category-additionals-extras-selected.vue?vue&type=template&id=31f882f3"
import script from "./category-additionals-extras-selected.vue?vue&type=script&lang=js"
export * from "./category-additionals-extras-selected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports